import { createAuth0 } from "@auth0/auth0-vue";

const envClients = import.meta.env.VITE_AUTH0_CLIENTIDS;

const domain = import.meta.env.VITE_AUTH0_DOMAIN;
const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

function getAuth0ClientIdFromCurrentHostname() {
	const hostname = window.location.hostname;
  	return envClients
    .split(",")
    .map((pair) => pair.split("|"))
	.sort(([domain1], [domain2]) => {
      return domain2.length-domain1.length
    })
    .find(([domain]) => hostname === domain || hostname.endsWith(`.${domain}`))?.[1];
}

const clientId = getAuth0ClientIdFromCurrentHostname();

export const auth0 = createAuth0({
	domain,
	clientId,
	useRefreshTokens: true,
	authorizationParams: {
		redirect_uri: window.location.origin,
		audience
	}
});
